module.exports = __webpack_public_path__ + "media/images/del-3eeb8c4e13bb5985543179d7b86e1dc6.png";